import {
  SegmentEvidenceActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
  type EventPropsOf,
} from '@heidi/analytics/events';
import {
  type EvidenceOnboardingSavedEventProps,
  type EvidenceOnboardingViewedEventProps,
} from '@heidi/evidence/contracts';

export function trackEvidenceOnboardingDismissed() {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.EvidenceOnboardingDismissed,
    props: {},
  });
}

export function trackEvidenceOnboardingSaved(input: EvidenceOnboardingSavedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.EvidenceOnboardingSaved,
    props: input,
  });
}

export function trackEvidenceNhsContactSalesSubmitted(
  input: EventPropsOf<TrackingEventName.EvidenceNhsContactSalesSubmitted>
) {
  trackLegacyEvent({
    name: SegmentObjectName.Evidence,
    props: {
      action: SegmentEvidenceActionName.EvidenceNhsContactSalesSubmitted,
    },
  });

  track({
    options: { amplitude: false },
    event_name: TrackingEventName.EvidenceNhsContactSalesSubmitted,
    props: input,
  });
}

export function trackEvidenceOnboardingSkipped() {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.EvidenceOnboardingSkipped,
    props: {},
  });
}

export function trackEvidenceOnboardingViewed(input: EvidenceOnboardingViewedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.EvidenceOnboardingViewed,
    props: input,
  });
}
